import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'contingent-search-card',
  templateUrl: './search-card.component.html',
  styleUrls: ['./search-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchCardComponent {}
